/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';

import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import JmpModal from './customModal';
import Select, { components } from 'react-select';
import loadsStore from '../../../stores/loads-store';
import { DropTarget, DragSource } from 'react-dnd'
import swal from 'sweetalert';

const Types = {
    ITEM: 'JUMP'
};

const itemSource = {
    beginDrag(props) {
        //console.log('dragging');
        const item = props
        return item
    },
    endDrag(props, monitor, component) {
        //console.log('endrag')
        if (!monitor.didDrop()) {
            return;
        }
        //return props.handleJumperDrop(props)
        return props;
    }
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
}

class RemovableJumper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            jumpType: null,
            load: props.load,
        };
    }

    setEditable = () => {
        // jumper can delete only oneself
        let userRole = localStorage.getItem("role");
        if (userRole && userRole === "jumper") {
            let jumperDetails = localStorage.getItem("jumperDetails")
            if (jumperDetails !== null) {
                jumperDetails = JSON.parse(jumperDetails);
            }

            if (this.props.jumper._id === jumperDetails._id) {
                this.setState({ editMode: !this.state.editMode, jumpType: null });
            }
        }
        else {
            this.setState({
                editMode: !this.state.editMode,
                jumpType: null
            });
        }

    }



    handleSubmit = (loadNum, jumpId, jumperId, timeRemaining) => {
        // console.log('deleting jumper');
        //console.log(loadNum + " jumpId: " + jumpId + " jumperId: "+jumperId);
        if (window.ENV?.disableRemoveAt8MinCall && timeRemaining < 480) {
            swal({
                title: "Warning",
                text: "cannot remove less than 8 min call",
                icon: "warning",
                dangerMode: false,
            })

        }
        else {
            loadsStore.removeJumper(loadNum, jumpId, jumperId);
        }
        this.setState({ editMode: false, jumpType: null })
    }

    // updateJumpType = (value, loadNum, jumpId) => {
    //     if (value.target.value !== "Select Jump Type") {
    //         var jumpBody = {
    //             jumpType: value.target.value
    //         }
    //         loadsStore.updateFunJumpType(loadNum, jumpId, jumpBody)
    //         this.setState({ editMode: !this.state.editMode });
    //     }
    // }

    render() {
        const { isDragging, connectDragSource, funJump, timeRemaining } = this.props;
        const opacity = isDragging ? 0 : 1;

        return connectDragSource(
            <div >
                <React.Fragment>
                    {/* <button className="btn lightBlueButton jumper-name" onClick={this.setEditable} type="submit" disabled={this.props.disabled}> */}
                    <div className={'name-container'} onClick={this.setEditable} disabled={this.props.disabled}>
                        <span style={this.props.type === "observer" ? {fontSize:"1.22em"} : {}}>
                        {this.props.type === "observer" ? "O: " : null}
                        <strong style={this.props.type === "observer" ? {marginLeft:"-1px"} : {}}>
                           {this.props.jumper.nickname !== undefined ? this.props.jumper.nickname : this.props.jumper.firstname} &nbsp;
                            {this.props.jumper.lastname !== undefined && this.props.jumper.lastname !== "" ? this.props.jumper.lastname?.substr(0, 1) : null}
                        </strong>
                        </span>
                        <div className="memberId">
                            <span className="inline-Id-and-gear" >
                                {this.props.jumper.memberId}
                                {this.props.jumper.gearRental ?  " (G)" : null}
                                {this.props.jumper.isLOing? <strong>(LO)</strong>:null}
                                {this.props.jumper.isVideographer?<>&nbsp; <i className="fa fa-xs fa-video-camera"> </i></>:null}
                            </span>
                            {this.state.editMode ?
                                <i
                                    onClick={(values) => this.handleSubmit(this.props.loadNum, this.props.jumpId, this.props.jumper._id, timeRemaining)} className='fa fa-close'>
                                </i> : null
                            }
                        </div>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

//  export default RemovableJumper
export default DragSource(Types.ITEM, itemSource, collect)(RemovableJumper)
